<template>
  <div class="animated fadeIn" @keyup.enter="onFilter">
    <div class="form-group row">
      <div class="col-md-12">
        <label> Email:</label>
        <div class="input-group mb-3">
          <b-form-input type="text"
                        :placeholder="'Digite a Nome do modelo'"
                        v-model="form.emailFrom.value"
                        :state="form.emailFrom.state"
                        autofocus
          />
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <label> Conexão Segura:</label>
          <div class="input-group">
            <b-form-select v-model="form.safeConnection.value" :options="form.safeConnection.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
      </div>
    </div>
    <div class="form-group row pt-3">
      <div class="col-md-12 pt-2">
        <button type="button" class="btn btn-third w-100" v-on:click="onFilter">Filtrar</button>
      </div>
      <div class="col-md-12 pt-2">
        <button type="button" class="btn btn-default w-100" v-on:click="onClearFilters">Limpar Filtros</button>
      </div>
    </div>
    <div class="form-group row" style="margin-top: 250px;">&nbsp;<!--Space to scroll--></div>
  </div>
</template>
<script>

import OriginSearch from './search.js'
export default OriginSearch

</script>



// WEBPACK FOOTER //
// src/views/private/configurations/email/components/search/search.vue